import { ButtonAnalyticsContext, ButtonAnalyticsContextValue } from "./ButtonAnalyticsContext";
import { ReactNode, useMemo } from "react";

/**
 * Props for ButtonAnalyticsProvider.
 */
export interface ButtonAnalyticsProviderProps extends ButtonAnalyticsContextValue {
    children?: ReactNode;
}

/**
 * Provides button analytics context to its children.
 * Wrap your component tree with this provider to supply analytics metadata
 * (such as namePrefix, applicationFeature, and location) to descendant components.
 */
export const ButtonAnalyticsProvider = ({
    children,
    namePrefix,
    applicationFeature,
    location,
}: ButtonAnalyticsProviderProps) => {
    const value = useMemo(
        () => ({ namePrefix, applicationFeature, location }),
        [namePrefix, applicationFeature, location]
    );

    return <ButtonAnalyticsContext.Provider value={value}>{children}</ButtonAnalyticsContext.Provider>;
};
